import './EnergiaSolar.css';
import React from "react";
import EnergiaSolar0 from '../../assets/Industries/EnergiaSolar/EnergiaSolar0.png';
import EnergiaSolar1 from '../../assets/Industries/EnergiaSolar/EnergiaSolar1.png';
import EnergiaSolar2 from '../../assets/Industries/EnergiaSolar/EnergiaSolar2.png';
import EnergiaSolar3 from '../../assets/Industries/EnergiaSolar/EnergiaSolar3.png';

const images = [
    { src: EnergiaSolar1, text: "Amorphous Silicon Solar" },
    { src: EnergiaSolar2, text: "Polysilicon Solar" },
    { src: EnergiaSolar3, text: "Thin Film Solar" },
];

function EnergiaSolar() {
    return (
        <div className="arquitectura-container">
            <div className="arquitectura-header">
                <div className="arquitectura-texto">
                    <h2>Energía Solar</h2>
                    <div className="underline"></div>
                    <p>
                        No solo proporcionamos productos de sellado solar seguros y confiables, sino que también brindamos soluciones de sellado solar, con nuestros más de 30 años de acumulación y enfoque de tecnología, para brindar a los clientes productos de la mejor calidad al mismo tiempo, más clientes para reducir los costos de producción. ¡Para que la energía limpia sea más barata es nuestro objetivo común a perseguir con usted!
                    </p>
                </div>
                <div className="arquitectura-imagen">
                    <img src={EnergiaSolar0} alt="Arquitectura" />
                </div>
            </div>

            {/* Sección de Imágenes en Grilla (justo debajo) */}
            <div className="arquitectura-grid">
                {images.map((item, index) => (
                    <div key={index} className="arquitectura-item">
                        <img src={item.src} alt={`Arquitectura ${index + 1}`} />
                        <p>{item.text}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default EnergiaSolar;
